import { Injectable } from '@angular/core';
import { NiceSdkAuthenticationService } from '../../data/CXOne/sdk-auth/nice-sdk-authentication.service';
import { LoggerService } from './logger.service';
import { EventHandlerService } from 'src/app/data/services/event-handler.service';
import { LocalStorageService } from 'src/app/data/services/local-storage.service';
import { DatadogService } from 'src/app/shared/services/data-dog.service';
import { quickWebLogger } from '@quickweb/logger';
import { LocalStorageUtils } from 'src/app/data/CXOne/util/LocalStorageUtils';
import { Central } from 'src/app/data/Dynamics/main-dynamics/dynamics-retrieve-config';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private authService: NiceSdkAuthenticationService,
    private logger: LoggerService,
    private datadogService: DatadogService,
    private eventHandler: EventHandlerService,
    private localStorage: LocalStorageService,
    private localStorageUtils: LocalStorageUtils,
  ) {}

  async login(
    authServiceType: string,
    centralId: string,
    authenticateStart: boolean,
    authMode: string,

    isResolverInitialization = false,
  ): Promise<boolean> {
    //this.logger.info(`LOGINSERVICE - Service: ${authServiceType} | Central ID: ${centralId}`);

    switch (authServiceType) {
      case 'nice': {
        this.storeAuthData(centralId, authServiceType, authMode);

        if (isResolverInitialization === false) {
          this.datadogService.sendDataWithTimeout(() => {
            quickWebLogger.logger.info('inicialização da autenticação');
          });
        }

        const isloggedtete = await this.validateLogin(
          authenticateStart,
          isResolverInitialization,
        );

        return isloggedtete;
      }
      default:
        this.logger.error(
          `LOGINSERVICE - Serviço de autenticacao nao especificado ou desconhecido: ${authServiceType}`,
        );
        return false;
    }
  }

  private storeAuthData(
    centralId: string,
    authServiceType: string,
    authMode: string,
  ): void {
    this.logger.info(`LOGINSERVICE - Central logada: ${centralId}`);

    const centralsWithSafeStorage: readonly string[] = [
      'ibba',
      'seguros-pf',
      'civics-v2',
      'civics',
      'gerentes-pf',
      'npc',
      'pf',
      'pj',
      'rede-pj',
    ];

    if (centralsWithSafeStorage.includes(centralId)) {
      this.localStorageUtils.safeSetItem('centralId', centralId);
      this.localStorageUtils.safeSetItem('authServiceType', authServiceType);
      this.localStorageUtils.safeSetItem('display_mode', authMode);
    } else {
      try {
        localStorage.setItem('centralId', centralId);
        localStorage.setItem('authServiceType', authServiceType);
        localStorage.setItem('display_mode', authMode);
      } catch (error) {
        this.logger.error(`${error}`);
        throw new Error(`${error}`);
      }
    }
  }

  private async validateLogin(
    authenticateStart: boolean,
    isResolverInitialization: boolean,
  ): Promise<boolean> {
    //this.logger.info('LOGINSERVICE - Iniciando autenticacao com o SDK NICE');
    try {
      if (await this.authService.isAuthenticated(isResolverInitialization)) {
        return true;
      }
      this.logger.info(`LOGINSERVICE - limpando localstorage`);
      this.eventHandler.clearProcessed();
      this.localStorage.clearAllLocalStorage();
      //this.logger.info('LOGINSERVICE - Usuário nao autenticado, iniciando autenticação');
      if (!authenticateStart) {
        this.logger.info(`Iniciando autenticacao.`);
        //this.logger.info('LOGINSERVICE - Chamando authenticate');
        await this.authService.authenticate(); //apenas bate na nice e retorna URL para login
        this.logger.info(`Autenticado.`);
      }
      //this.logger.info('LOGINSERVICE - Chamando initialize');
      await this.authService.initialize(); //aguarda o token
      //this.logger.info('LOGINSERVICE - Autenticação com SDK NICE concluída com sucesso');
      return await this.authService.isAuthenticated(isResolverInitialization);
    } catch (error) {
      this.logger.error('LOGINSERVICE - Erro durante autenticação: ' + error);
      return false;
    }
  }
}
